type IRawData = Record<string, string>;

/**
 * TODO: Make sure this formatter catches all cases
 * @param raw
 * @deprecated There should be a proper row id from server
 */
export function composeRowId(raw: IRawData): string | undefined {
  if (raw["id"]) {
    return raw["id"];
  } else if (raw["sku"]) {
    return raw["sku"];
  } else if (raw["ALNR"]) {
    return composeOriginalSupplyId(raw);
  } else if (getOrderNumber(raw)) {
    return composeOrderHistoryId(raw);
  } else {
    return composeSystemMaterialId(raw);
  }
}

function composeSystemMaterialId(raw: IRawData): string | undefined {
  const systemId = getSourceSystem(raw);
  const materialNumbers = [getMaterialNumber(raw), getOldMaterialNumber(raw)];
  const filtered = materialNumbers.filter(Boolean);
  if (!filtered.length) {
    return;
  }
  return `${systemId}|${materialNumbers.filter(Boolean).join("~")}`;
}

function composeOriginalSupplyId(raw: IRawData): string {
  return `${raw["PM_No"]}~${raw["SYSWERK"]}~${raw["ORDERID"]}~${raw["ZZINFO"]}`;
}

function composeOrderHistoryId(raw: IRawData): string {
  if (raw["salesDocumentId"]) {
    return raw["salesDocumentId"];
  }
  if (raw["documentId"]) {
    return raw["documentId"];
  }
  const identifiers = [getSourceSystem(raw), getOrderNumber(raw), getPositionNumber(raw)]; // TODO: use pos no instead ?
  return identifiers.filter(Boolean).join("/");
}

export interface ILegacyOrderHistoryDocument extends IRawData {
  SOURCESYSTEM: string;
  VBELN: string;
}

export const getOrderNumber = (raw: IRawData): string | undefined => raw["document_number"] || raw["VBELN"] || raw["DOC_NUMBER"];

export const getSourceSystem = (raw: IRawData): string => raw["sysid"] || raw["SYSID"] || raw["SOURCECYSYSTEM"] || "SAPVP";

export const getMaterialNumber = (raw: IRawData): string => raw["EKCR_MATNR"] || raw["MATNR"] || raw["SANR"] || raw["DOC_ADDITIVE_ID"] || raw["id"]!;

export const getOldMaterialNumber = (raw: IRawData): string => raw["EKCR_MATNR_OLD"] || raw["EKCR_MATNR"] || raw["MATNR"] || raw["SANR"] || raw["id"]!;

export const getPositionNumber = (raw: IRawData): string => raw["ITM_NUMBER"]!;
